import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-lista-titulo-desc',
  templateUrl: './lista-titulo-desc.component.html',
  styleUrls: ['./lista-titulo-desc.component.scss']
})
export class ListaTituloDescComponent implements OnInit {

  @Input() cols = 3;
  @Input() elements:any = [];
  @Input() filterType:string[] = ['MEDIA'];
  @Input() templateNome = "";
  templateValidoImg;

  

  imagePathOk = "https://s3.amazonaws.com/unionsolutions-assets/images/check-laudo.png";
  imagePathWarn = "https://s3.amazonaws.com/unionsolutions-assets/images/alert-laudo.png";

  showElements:any = [];
  constructor() { }

  ngOnInit() {
    if(this.templateNome == "analiseEstrutura" || this.templateNome == "etiquetas" || this.templateNome == "analiseIdentificacao"){
      this.templateValidoImg = true
    }else{
      this.templateValidoImg = false
    }
  }
  
  ngOnChanges() {
    this.showElements = this.elements.filter( e => !this.filterType.find(( t => t == e.type )) )
  }

}
